import { useProgressStore } from '~/store/progress'
import { useQuestionsStore } from '~/store/questions'
import { useBorrowerStore } from '~/store/borrower'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { useDealsStore } from '~/store/deals'
import { parseISO } from 'date-fns'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const nuxtApp = useNuxtApp()
  const { $pinia } = nuxtApp
  const borrowerStore = useBorrowerStore($pinia)
  const progressStore = useProgressStore($pinia)
  const questionsStore = useQuestionsStore($pinia)
  const affiliateCustomizationStore = useAffiliateCustomizationStore($pinia)
  const dealsStore = useDealsStore($pinia)

  const query = to.query
  let type = query.type
  const isLogin = query.login
  const lastInteractedApp = progressStore.lastInteractedApp
  type = query.type ?? lastInteractedApp.type

  if (isLogin && type == 'marketplace') {
    const mpApplicationComplete = borrowerStore.mpApplicationComplete
    const expirationTime = 30 * 24 * 60 * 60 * 1000
    if (mpApplicationComplete && !((new Date() - parseISO(mpApplicationComplete)) > expirationTime)) {
      let dashboardPath
      if (affiliateCustomizationStore.isIntelligentLendingAffiliate) {
        await dealsStore.getDealsWithOffers()
        if (dealsStore.dealWithAcceptedOffer) {
          dashboardPath = '/intelligent-lending/portal/dashboard'
        }
        else {
          dashboardPath = '/intelligent-lending/portal'
        }
      }
      else {
        dashboardPath = '/portal'
      }

      return nuxtApp.runWithContext(() => navigateTo(dashboardPath))
    } else {
      return nuxtApp.runWithContext(() => navigateTo(progressStore.resumeApplicationRoute(type)))
    }
  } else {
    if (lastInteractedApp.type === 'sba-complete' && lastInteractedApp.completed) {
      return nuxtApp.runWithContext(() => navigateTo('/sba-complete/portal'))
    } else {
      await Promise.all([
        progressStore.updateApplication({ type }),
        progressStore.executeRequiredActions({appName: type}),
        type == 'marketplace' ? questionsStore.initializeInfoPage() : null
      ])
      const resumeAppRoute = progressStore.resumeApplicationRoute(type)
      return nuxtApp.runWithContext(() => navigateTo(resumeAppRoute))
    }
  }
})
